<template>
	<popup ref="popup" :loading="popupLoading">
		<div slot="body">
			<el-form class="dataForm" ref="form" :disabled="disabled" :model="formParameter" :inline="true" label-width="80px"
				:rules="rules">
				<!-- <el-row>
					<el-col :span="24">
						 <p>类型:</p>
						<el-form-item label="1.学校" prop="name">
							<el-input v-model="formParameter.name" autocomplete="off"></el-input>
						</el-form-item> -->
				<!-- <el-form-item label="2.专业" prop="type">
							<el-input v-model="formParameter." autocomplete="off"></el-input></el-form-item>
					</el-col>
				</el-row> -->
				<el-row>
					<el-col :span="24">
						<el-form-item label="姓名" prop="name"><el-input v-model="formParameter.name"
								autocomplete="off"></el-input></el-form-item>
					</el-col>
				</el-row>
				<!-- <el-row>
					<el-col :span="24">
						<el-form-item label="logo" prop="name">
							<template slot-scope="scope">
								<el-image style="width: 100px; height: 100px"></el-image>
							</template>
						</el-form-item>
					</el-col>
				</el-row> -->

				<!-- 上传图片的组件 -->
				<el-col :span="10" class="userHead" style="margin-left: 80px;">
					<!-- <img id="headImg" :src="user.head" v-if="user.head" /> -->
					<!-- <img id="headImg" src="~assets/img/male.jpg" /> -->

					<drag-file-upload @change="change" v-model="formParameter.logo" drag uri="/statics/logo"
								model="fileSystem" :size="300"></drag-file-upload>

					<div style=" font-weight: bold;">
                                    图标推荐:{{ formParameter.type==1?'200*200':'300*180' }}
					</div>
				</el-col>

				<el-col :span="8" class="userHead" style="margin-left: 80px;">
					<el-image :src="baseURI+formParameter.logo" style="width: 200px;"></el-image>
				</el-col>

				<el-col :span="24" style="margin-top: 20px;">
					<el-form-item label="类型" prop="type">
						<select-option-dictionary v-model="formParameter.type" dkey="logo-type">
						</select-option-dictionary>
					</el-form-item>
				</el-col>
			</el-form>
		</div>
		<div slot="footer">
			<el-button v-if="!disabled" type="primary" :loading="confirmLoading" @click="confirm()">确 定</el-button>
			<el-button @click="close">取 消</el-button>
		</div>
	</popup>
</template>

<script>
import selectOptionDictionary from '@/components/biz/selectOptionDictionary/selectOptionDictionary.vue';
import popup from '@/components/popup/drawerPopup.vue';
import dragFileUpload from '@/components/biz/fileUpload/dragFileUpload.vue';
import api from '@/api/xueli/logo.js';
import constant from '@/util/constant.js';

export default {
	name: 'edit',
	components: {
		popup,
		selectOptionDictionary,
		dragFileUpload
	},
	data() {
		return {
			imageUrl: '',
			userInfo: {},
			disabled: false,
			popupLoading: false,
			confirmLoading: false,
			parameter: {},
			formParameter: {},
			baseURI: constant.serverUrl,
			rules: {
				//类型,1:学校，2.专业
				type: [
					{
						validator: this.$validate.required,
						trigger: 'blur'
					},
					{
						validator: this.$validate.length,
						max: 35,
						trigger: 'blur'
					}
				],
				//
				name: [
					{
						validator: this.$validate.required,
						trigger: 'blur'
					},
					{
						validator: this.$validate.length,
						max: 255,
						trigger: 'blur'
					}
				],
				//
				logo: [
					{
						validator: this.$validate.required,
						trigger: 'blur'
					}
				],
			}
		};
	},
	methods: {

		change(val) {

			if(this.formParameter.logo && this.formParameter.logo.indexOf('/statics/')>0 ){
				  this.formParameter.logo = this.formParameter.logo.substring( this.formParameter.logo.indexOf('/statics/') ) 
			}
	
		},
		selectOptionDictionary() {

		},

		//打开弹框
		open(parameter, title, disabled, size) {
			this.parameter = parameter;
			this.disabled = disabled;
			this.$refs.popup.open(title, size);
			this.$nextTick(() => {
				this.init();
			})
		},
		//关闭弹框
		close() {
			this.disabled = false;
			this.$refs.popup.close();
		},
		//提交表单
		confirm() {
			this.$utils.checkForm(this.$refs.form, () => {
				this.confirmLoading = true;
				if (!this.parameter.id) {
					//添加
					let parameter = this.$utils.merger(this.formParameter);
					api.save(parameter,
						response => {
							this.$utils.msg.success(response.msg);
							this.confirmLoading = false;
							this.close();
							this.$parent.list();
						},
						response => {
							this.$utils.msg.warning(response.msg);
							this.confirmLoading = false;
						}
					);
				} else {
					//编辑
					let parameter = this.$utils.merger(this.formParameter);
					api.update(parameter,
						response => {
							this.$utils.msg.success(response.msg);
							this.confirmLoading = false;
							this.close();
							this.$parent.list();
						},
						response => {
							this.$utils.msg.warning(response.msg);
							this.confirmLoading = false;
						}
					);
				}
			});
		},
		init() {
			this.popupLoading = true;
			//清除等待
			this.confirmLoading = false;
			//清空内容
			this.formParameter = {};
			//清楚校验
			this.$refs.form.clearValidate();

			if (this.parameter.id) {
				//编辑查询数据
				let parameter = {
					id: this.parameter.id
				};
				api.toUpdate(parameter, response => {
					this.formParameter = response.data;
					this.popupLoading = false;
				});
			} else {
				//添加
				this.popupLoading = false;
			}
		}
	}
};
</script>

<style lang="scss" scoped="scoped">
@import '~common/custom/css/common.scss';
@import '~common/custom/css/popup/popup.scss';
</style>
